/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface ICheckoutTermsAndConditionsErrorTitleProps {
    title?: string;
}

/**
 * AddPaymentForm SFC.
 * @param root0
 * @param root0.title
 * @extends {React.FC<ICheckoutTermsAndConditionsErrorTitleProps>}
 */
const CheckoutTermsAndConditionsErrorTitle: React.FC<ICheckoutTermsAndConditionsErrorTitleProps> = ({
    title
}) => {
    if (!title) {
        return null;
    }

    return (
        <p className='ms-checkout-terms-and-conditions__error-title'>
            {title}
        </p>
    );

};

export default CheckoutTermsAndConditionsErrorTitle;
